(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    // Rating/Q&A jump under the product title: open the target accordion tab, then scroll to it
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('[data-rating-jump], [data-rating-jump-stars]');
    if (!trigger) return;

    const link = trigger.matches('a[data-rating-jump]')
      ? trigger
      : trigger.closest('.rating-wrapper')?.querySelector('a[data-rating-jump]');
    const targetId = link?.getAttribute('href')?.slice(1);
    const target = targetId ? document.getElementById(targetId) : null;
    if (!(target instanceof HTMLDetailsElement)) return;

    event.preventDefault();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveal = () => {
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      target.querySelector('summary')?.focus({ preventScroll: true });
    };

    if (target.open) {
      reveal();
      return;
    }

    // The accordion's single-open handler collapses the other tabs on toggle; scroll once layout settles
    target.addEventListener('toggle', () => requestAnimationFrame(reveal), { once: true });
    target.open = true;
  });
  } catch(e) { console.error(e); }
})();

})();
